import { ReactNode } from 'react';
import { LanguageCode } from '../core';
import {
  DesignChannelType,
  DesignModuleLocalVariable,
  DesignVariable
} from '../design';
import { ConfigViewType } from './config-view-type';

export type BooleanConfigView = {
  context: unknown;
  key: string;
  label: string;
  no: string;
  type: ConfigViewType.boolean;
  yes: string;
};

export type ButtonConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.button;
};

export type CommonModuleVersionDropDownConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.commonModuleVersionDropDown;
};

export type ConditionConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.condition;
};

export type DropdownConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.dropdown;
};

export type DtmfDropDownConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.dtmfDropDown;
};

export type ExitComponentConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.exitComponent;
};

export type FormListDropDownConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.formListDropDown;
};

export type FormVersionsDropDownConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.formVersionsDropDown;
};

export type FunctionConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.function;
};

export type HrConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.hr;
};

export type InputConfigView = {
  context?: unknown;
  defaultValue?: string;
  disabled?: boolean;
  hint?: string;
  input?: unknown;
  inputRules?: Record<string, unknown>;
  key: string;
  label: string;
  suggestion?: string;
  tooltip?: string;
  type: ConfigViewType.input;
  valRules?: Record<string, unknown>;
  value?: string;
  variable?: DesignModuleLocalVariable | DesignVariable;
};

export type IntentDropdownConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.intentDropdown;
};

export enum ItemListConfigViewView {
  argument = 'argument',
  customHeader = 'customHeader',
  dynamicVariableReference = 'dynamicVariableReference',
  examplePhrases = 'examplePhrases',
  keyValue = 'keyValue',
  localIntent = 'localIntent',
  moduleInputs = 'moduleInputs',
  moduleReturn = 'moduleReturn',
  replyButton = 'replyButton',
  return = 'return',
  routerArgument = 'routerArgument',
  routerReturn = 'routerReturn',
  variableReference = 'variableReference'
}

export type ItemListConfigView = {
  context?: unknown;
  key: string;
  label: string;
  options?: unknown;
  readOnly?: boolean;
  tooltip?: string;
  type: ConfigViewType.itemList;
  userType?: string[];
  view: ItemListConfigViewView;
};

export type JsxConfigView = {
  content: ReactNode;
  label: string;
  tooltip?: string;
  type: ConfigViewType.jsx;
};

export type KeySwitchConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.keySwitch;
};

export type KeyValueConfigView = {
  inputIndex: number;
  key: number;
  label: ReactNode;
  layout: 'keyedLabel';
  pair: {
    key: string;
    value: string;
  };
  pairKeyView: ConfigView;
  pairValueView: ConfigView;
  type: ConfigViewType.keyValue;
  variableName: string;
};

export type LabelConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.label;
};

export type MenuConfigView = {
  key: string;
  optionName: string;
  options: {
    action: string;
    name: string;
  }[];
  type: ConfigViewType.menu;
};

export type ModuleParamDropdownConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.moduleParamDropdown;
};

export type NestedPropertiesConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.nestedProperties;
};

export type PlavSavedPromptKeyDropdownConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.plavSavedPromptKeyDropdown;
};

export type PromptDropdownConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.promptDropdown;
};

export type PromptTextareaConfigView = {
  context: unknown;
  type: ConfigViewType.promptTextarea;
  key: string;
  value: string;
  lang: LanguageCode;
  /** @deprecated in favor of handling selected channel globally */
  channelLayer?: DesignChannelType;
};

export type ScopeHintConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.scopeHint;
};

export type SliderConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.slider;
};

export type SwitchConfigView = {
  defaultValue: string;
  disabled: boolean;
  input: unknown;
  suggestion: string;
  type: ConfigViewType.switch;
  value: string;
  variable: DesignModuleLocalVariable | DesignVariable;
};

export type TagListConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.tagList;
};

export type TextareaConfigView = {
  key: string;
  label: string;
  type: ConfigViewType.textarea;
};

export type WrappedItemListConfigView = {
  // TODO: Finish adding typedef.
  type: ConfigViewType.wrappedItemList;
};

export type ConfigView = (
  BooleanConfigView
  | ButtonConfigView
  | CommonModuleVersionDropDownConfigView
  | ConditionConfigView
  | DropdownConfigView
  | DtmfDropDownConfigView
  | ExitComponentConfigView
  | FormListDropDownConfigView
  | FormVersionsDropDownConfigView
  | FunctionConfigView
  | HrConfigView
  | InputConfigView
  | IntentDropdownConfigView
  | ItemListConfigView
  | JsxConfigView
  | KeySwitchConfigView
  | KeyValueConfigView
  | LabelConfigView
  | MenuConfigView
  | ModuleParamDropdownConfigView
  | NestedPropertiesConfigView
  | PlavSavedPromptKeyDropdownConfigView
  | PromptDropdownConfigView
  | PromptTextareaConfigView
  | ScopeHintConfigView
  | SliderConfigView
  | SwitchConfigView
  | TagListConfigView
  | TextareaConfigView
  | WrappedItemListConfigView
  /** @deprecated Stop adding empty objects as config views. */
  | Record<string, never>
  | null
);
